'use strict';

import { getJourney, notifyJourneyModal, updateJourney } from './journeyHelper';

export default class VZJourney extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.addEventListener('deselect', this.setState);
        this.setState();
        this.showOrHideDependingOnBusinessInternetAccess();
        document.addEventListener('postcodeChanged', this.showOrHideDependingOnBusinessInternetAccess.bind(this));
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('deselect', this.setState);
        document.removeEventListener('postcodeChanged', this.showOrHideDependingOnBusinessInternetAccess.bind(this));
    }

    onChange() {
        const id = this.querySelector('input[name$=_journey]')?.id;
        if (id.includes('_dummy')) {
            this.constructor.removeStep(id);
        } else {
            this.constructor.addStep(id);
        }
        this.setState();
        this.triggerLinkedProduct();
    }

    setState() {
        const inputField = this.querySelector('input[name$=_journey]');
        const { id } = inputField;
        const journey = getJourney();
        if (journey.indexOf(id) !== -1 || (id.includes('_dummy') && journey.indexOf(id.split('_dummy')[0]) === -1)) {
            inputField.setAttribute('checked', 'checked');
            inputField.setAttribute('disabled', 'disabled');
        } else {
            inputField.removeAttribute('checked');
            inputField.removeAttribute('disabled');
        }
    }

    triggerLinkedProduct() {
        const id = this.querySelector('input[name$=_journey]')?.id;
        const linkedProductID = id.includes('_dummy') ? id.split('_dummy')[0] : `${id}_dummy`;
        const linkedProduct = document.querySelector(`vz-journey input[type="radio"]#${linkedProductID}`);
        linkedProduct.closest('vz-journey').dispatchEvent(new CustomEvent('deselect'));
    }

    showOrHideDependingOnBusinessInternetAccess() {
        const isBIAvailable = !document.querySelector('.js-availability-response-address')?.hasAttribute('unabletoorder');
        const journeyCardElement = this.closest('.js-pdp-card-section');
        if (isBIAvailable) {
            journeyCardElement.classList.remove('d-none');
        } else {
            journeyCardElement.classList.add('d-none');
        }
    }

    static addStep(productID) {
        const journey = getJourney();

        journey.push(productID);
        const journeyArray = [...new Set(journey)]; // ensure unique values
        updateJourney(journeyArray);
        notifyJourneyModal(journeyArray);
    }

    static removeStep(productID) {
        const journey = getJourney();
        const index = journey.indexOf(productID.split('_dummy')[0]);
        if (index > -1) {
            journey.splice(index, 1);
            updateJourney(journey);
            notifyJourneyModal(journey);
        }
    }
}

if (!window.customElements.get('vz-journey')) {
    window.customElements.define('vz-journey', VZJourney);
}
